import CircularProgress from '@mui/material/CircularProgress';

export const Loading = () => (
	<div style={{ height: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
		<CircularProgress />
	</div>
);